export default "__VITE_ASSET__xVvco4mT__"